import StoreDetail from './StoreDetail';

export default StoreDetail;



// WEBPACK FOOTER //
// ./src/scenes/Stores/StoreDetail/index.ts